import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const FILTER__FORM_FIELDS_GLOBAL = {
    thirdPartyCodes: [],
    banks: [],
    searchByValue: ""
};

export const newRow = {
    country: "",
    countryCode: "",
    thirdPartyCode: "",
    name: "",
    beneficiaryName: "",
    accountNumber: "",
    bank: "",
    ifsc: "",
    phoneNumber: "",
    status: "ACTIVE"
}


export const getCreateUpdateRequestBody = (form) => {
    const { country, countryCode, thirdPartyCode, name, beneficiaryName, accountNumber, bank, ifsc, phoneNumber, isNew, id, status } = form;
    return {
        ...(!isNew && { id }),
        country: country?.label,
        countryCode,
        thirdPartyCode: thirdPartyCode?.label,
        name,
        beneficiaryName,
        accountNumber,
        bank: bank?.label,
        bankKey: bank?.bankId,
        bankMasterId: bank?.id,
        ifsc,
        phoneNumber,
        status
    }
}

export const getDropdowns = async () => {
    const resp = await Promise.all([
        dropdownMapping(
            endpoint.country.getAllActive,
            "countryDesc",
            "countryCode",
        ),
        fetchAllPostPromisedData(
            `${endpoint.bankMaster.search}?offset=-1`,
            {}
        ),
        dropdownMapping(
            endpoint.paymentMode.getAllActivePaymentCategory,
            "displayValue",
            "id",
            "status"
        ),
    ]);

    const bankList = resp[1]?.data?.bankMasterList ?? [];
    const paymentCategory = resp[2];

    const includedLabels = ["third-party", "loan"];

    const filteredPaymentCategory = paymentCategory?.filter(item =>
        includedLabels?.includes(item?.label?.toLowerCase())
    );

    const thirdPartyModeReq = {
        "paymentMode": "",
        "paymentModeDesc": "",
        "processTypeIds": [],
        "roleIds": [],
        "paymentCategories": filteredPaymentCategory?.map(e => e?.value),
        "paymentTypes": []
    };

    const thirdPartyListResp = await fetchAllPostPromisedData(
        `${endpoint.paymentMode.search}?offset=0`,
        thirdPartyModeReq
    );

    const thirdPartyList = thirdPartyListResp?.data ?? [];
    const activeThirdPartyModes = thirdPartyList
        ?.filter(mode => mode?.status?.toLowerCase() == "active")
        ?.map(mode => ({
            ...mode,
            label: mode?.paymentModeKey,
            value: mode?.paymentModeDesc
        }));

    return {
        allCountries: resp[0],
        allBanks: bankList?.map(bank => ({ ...bank, label: bank?.bankName, value: bank?.id })),
        thirdPartyPaymentMode: activeThirdPartyModes
    };
};

export const getUpdatedData = (resp, dropdowns) => {
    const updatedData = resp?.data?.paginatedData?.map(({
        country,
        thirdPartyCode,
        bank,
        ...rest
    }) => ({
        ...rest,
        country: dropdowns?.allCountries?.find(c => c?.label == country),
        thirdPartyCode: dropdowns?.thirdPartyPaymentMode?.find(mode => mode?.label == thirdPartyCode),
        bank: dropdowns?.allBanks?.find(b => b?.label?.toLowerCase() == bank?.toLowerCase())
    }));

    return updatedData;
};

export const selectStyles = {
    control: {
        borderRadius: '4px',
        height: '32px'
    }
}
export const inputStyles = {
    borderRadius: '4px',
    height: '32px'
}
